(ns hai.ui.components.tooltip
  "Humble-styled tooltip: reuses Radix Themes' Tooltip (`c/Tooltip`) for its
   accessible behaviour — hover + keyboard-focus triggers, Esc dismiss, portal
   escape past clipping ancestors, collision-aware flip positioning, hoverable/
   persistent content, and reduced-motion-gated animation — and layers the
   Ink/Chalk visual spec on top via a custom content class, since Radix
   Themes' own tooltip look (grey background, arrow, slide+fade) doesn't
   match brand styling."
  (:require
   [garden.stylesheet]
   [hai.ui.components :as c]
   [lambdaisland.ornament :as o]))

#_{:clj-kondo/ignore [:clojure-lsp/unused-public-var]}
(o/defrules tooltip-fade-keyframes
  (garden.stylesheet/at-keyframes
   :hai-tooltip-fade-in
   [:from {:opacity "0"}]
   [:to {:opacity "1"}])
  (garden.stylesheet/at-keyframes
   :hai-tooltip-fade-out
   [:from {:opacity "1"}]
   [:to {:opacity "0"}]))

;; `&.rt-TooltipContent` (rather than a bare selector) so every declaration
;; outranks Radix Themes' own same-specificity `.rt-TooltipContent` rules
;; regardless of stylesheet load order.
(o/defstyled tooltip-content :div
  [:&.rt-TooltipContent
   {:background-color "#1E085D"
    :color "#F6F5F0"
    :font-family "Manrope, sans-serif"
    :font-size "13px"
    :font-weight "500"
    :line-height "1.4"
    :padding "8px 10px"
    :border-radius "6px"
    :max-width "220px"
    :box-sizing "border-box"
    :animation "none"}]
  ;; No arrow.
  [:.rt-TooltipArrow {:display "none"}]
  ;; Opacity-only fade, both directions; nothing here under reduced motion, so
  ;; open/close is an instant show/hide instead.
  [:at-media {:prefers-reduced-motion "no-preference"}
   ["&.rt-TooltipContent[data-state='delayed-open']"
    {:animation "hai-tooltip-fade-in 0.2s ease-out"}]
   ["&.rt-TooltipContent[data-state='instant-open']"
    {:animation "hai-tooltip-fade-in 0.2s ease-out"}]
   ["&.rt-TooltipContent[data-state='closed']"
    {:animation "hai-tooltip-fade-out 0.2s ease-in"}]])

(defn tooltip
  "Wraps a single child with a Humble-styled tooltip above it, 8px gap, left-
   aligned to the child's left edge (flips below if there's no room above).
   `content` is the tooltip's exact copy."
  [{:keys [content]} & children]
  (into [c/Tooltip
         {:content content
          :className (str tooltip-content)
          :delayDuration 400
          :side "top"
          :sideOffset 8
          :align "start"
          :avoidCollisions true}]
        children))
